import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormlyFieldAnyComponent } from '@app/shared/components/formly-components/formly-field-any/formly-field-any.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { AutoResizeDirective } from '@app/core/directives/AutoResize/auto-resize.directive';

@Component({
  selector: 'app-formly-field-text',
  templateUrl: './formly-field-text.component.html',
  styleUrls: ['./formly-field-text.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormlyModule,
    AutoResizeDirective,
  ],
})
export class FormlyFieldTextComponent extends FormlyFieldAnyComponent {

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super();
  }
  
  public getMaxLength(): number {
    return this.field.props?.maxLength || 255;
  }

  public getCharacterCount(): number {
    return this.formControl.value?.trim().length || 0;
  }

  public onValueChange(event: any): void {
    const value = event.target?.value || event.detail?.value || '';
    this.formControl.setValue(value);
    // Trigger onChange callbacks if defined
    this.onChange(value);
    this.changeDetectorRef.markForCheck();
  }
}
